import React from "react";
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 4
    },
  },
})
//import SnapshotApp from './components/placename'
import MapChooserApp from './components/map-chooser'

const App = (settings) => {


  return (
    <QueryClientProvider client={queryClient}>
      <MapChooserApp {...settings} />
    </QueryClientProvider>
  )
}



const app = document.querySelector('.linz-map-chooser-view');


if(app) {

  const settings = drupalSettings.linz_map_chooser;
  const root = createRoot(app)

  root.render(<App {...settings} />)
}
